import styles from './Chart.module.scss';

interface Props {
  th: boolean;
  content: string | number;
}

export const Cell = ({ th, content }: Props) =>
  th ? <th className={styles.header}>{content}</th> : <td className={styles.cell}>{content}</td>;
